import { useState } from 'react';
import { VirtualMarathonCarousel, HubspotBrochureDownload } from '.'
import { Collapse, UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap'

const VirtualMarathonGuide = (props) => {
    return (
        <>
		<section className="contentmainN ptb0 mt-5">
			<div className="container customCampaignContainer">
				<div className="row d-flex align-items-center">
					<div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 ">
					<div className="subTextHeading text-left">You will get to learn:</div>
					<div>
						<ul className="mainbullets mt-4">
							<li>What is a Virtual Marathon?</li>
							<li>What are the advantages of a Virtual Marathon?</li>
							<li>How to start a Virtual Marathon?</li>
							<li>How to create a fun Virtual Marathon with Vantage Fit?</li>
						</ul>
					</div>
					</div>
					<div  className="col-lg-6 col-md-6 col-sm-6 col-xs-12 text-center" id="implementationCarousel">
					<VirtualMarathonCarousel/>
					</div>
				</div>
			</div>
		</section>
		<div id="downloadForm"></div>
		<section className="sectionSpacing" >
			<div className="container customCampaignContainer">
				<div className="row">
                    <div className="col-md-6 col-md-offset-2  col-sm-offset-2 col-xs-12 col-sm-12 col-lg-6 col-lg-offset-2 text-center shadow" style={{margin:"auto", borderRadius:"16px", padding: "60px 30px"}}>
						<div className="mainHeadingN ">Download Now</div>
						<div className="innerSpace">
						<HubspotBrochureDownload formID="e75b8bb9-f724-4a98-80d9-4cd6e2dbce48"/>
						</div>
					</div>

				</div>
			</div>
		</section>
        </>
    );
}

export default VirtualMarathonGuide;



